import type { FC } from 'react';

import PageLayoutDesktop from 'src/components/account/PageLayout/PageLayoutDesktop';

import LoginSelector from './components/LoginSelector';

const LoginPageDesktop: FC = () => (
  <PageLayoutDesktop>
    <LoginSelector />
  </PageLayoutDesktop>
);

export default LoginPageDesktop;
